import { render, staticRenderFns } from "./SavingButton.vue?vue&type=template&id=a2e30330&"
import script from "./SavingButton.vue?vue&type=script&lang=js&"
export * from "./SavingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports